import { supabaseClient } from '../auth/client';

// Re-export using the new Electron-safe client
export const supabase = supabaseClient;
